import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Tx from "../Tx";
import Text from "../Text";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { api } from "../../maps/data.js";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Divider from "@mui/material/Divider";
import { addCamera_checkConnectivity } from "../../domain/socketSlice";
import DiscoverOnvifDialog from "./DiscoverOnvifDialog";
import Connecting from "../Connecting";
import { getEdgeResponse } from "../../maps/data.js";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormLabel from "@mui/material/FormLabel";
import styled from "styled-components";

const ActionsWrapperStyled = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  align-items: end;
`;

export default function CameraDialog(props) {
  const {
    open,
    onClose,
    newCamera,
    camera = {},
    edgeId,
    forceFieldUpdate,
    forceSiteUpdate,
    site,
  } = props;

  const siteCameras = site.cameras || [];
  const checkInCamera = siteCameras?.find((cam) => cam.type === "CHECKIN");

  const [name, s_name] = useState(camera.name || "");
  const [port, s_port] = useState(camera.port || "");
  const [serial_number, s_serial_number] = useState(camera.serial_number || "");
  const [connecting, s_connecting] = useState(false);
  const [onvif_addr, s_onvif_addr] = useState(camera.onvif_addr || "");
  const [ip, s_ip] = useState(camera.ip || "");
  const [pt, s_pt] = useState(camera.pt || false);
  const [z, s_z] = useState(camera.z || false);
  const [open_discover_onvif_dialog, s_open_discover_onvif_dialog] =
    useState(false);
  const [username, s_username] = useState(camera.username || "admin");
  const [password, s_password] = useState(camera.password || "123456");
  const [rtspUrl, s_rtspUrl] = useState(camera.rtspUrl || "");
  const [connectionType, s_connectionType] = useState(
    camera.connectionType || "MANUAL"
  );
  const [connection_credentilas_changed, s_connection_credentilas_changed] =
    useState(false);
  const [rotate, s_rotate] = useState(camera.rotate || "0");
  const [aiProfile, s_aiProfile] = useState(camera.aiProfile || "");
  const [viewProfile, s_viewProfile] = useState(camera.viewProfile || "");
  const [profile_list, s_profile_list] = useState(camera.profile_list || []);
  const [isCheckInCamera, s_isCheckInCamera] = useState(checkInCamera || false);
  const [cameraSiteType, s_cameraSiteType] = useState(
    camera.cameraSiteType || ""
  );
  const [isConnected, s_isConnected] = useState(false);

  const save = async () => {
    let connectionStatus = true;

    if (connection_credentilas_changed) {
      connectionStatus = await connect();
    }
    if (connectionStatus) {
      await api({
        type: newCamera ? "addCamera" : "editCamera",
        data: {
          name,
          port,
          serial_number,
          ip,
          username,
          password,
          rtspUrl,
          connectionType,
          onvif_addr,
          edgeId,
          viewProfile,
          aiProfile,
          profile_list: profile_list,
          camera_info: connectionStatus.camera_info,
          pt,
          z,
          siteId: site._id,
          cameraSiteType,
          _id: camera._id,
          rotate: Number(rotate),
        },
      });
      forceFieldUpdate && forceFieldUpdate();
      onClose();
    }
    if (isCheckInCamera && !checkInCamera) {
      siteCameras.push(isCheckInCamera);
      await api({
        type: "editSite",
        data: {
          cameras: siteCameras,
          _id: site._id,
          name: site.name,
        },
      });
      forceSiteUpdate();
    }
    if (!isCheckInCamera && checkInCamera) {
      const siteCamerasWithOutCheckInCamera = siteCameras.filter(
        (cm) => cm.cameraId !== checkInCamera.cameraId
      );
      await api({
        type: "editSite",
        data: {
          cameras: siteCamerasWithOutCheckInCamera,
          _id: site._id,
          name: site.name,
        },
      });
      forceSiteUpdate();
    }
  };

  const connect = async () => {
    s_connecting(true);
    const responseId = `${edgeId}-${new Date().getTime()}`;
    addCamera_checkConnectivity({
      responseId,
      edgeId,
      name,
      port,
      ip,
      username,
      password,
      rtspUrl,
      connectionType,
      onvif_addr,
      serial_number,
    });
    const response = await getEdgeResponse(responseId);
    s_connecting(false);    

    if (!response.success) {
      window.messageBox(response.msg || "Connection failed");
      return false;
    }

    s_isConnected(true);

    console.log("addCamera_checkConnectivity response:", response);
    //update the profile list
    s_aiProfile(response.data.profile_list[0].name);
    s_viewProfile(response.data.profile_list[1].name);
    s_profile_list(response.data.profile_list);
    s_onvif_addr(response.data.onvif_addr);
    s_ip(response.data.ip);

    window.messageBox(response.msg || "Connection success");
    return {
      profile_list: response.data.profile_list,
      camera_info: response.data.camera_info,
      onvif_addr: response.onvif_addr,
    };
  };

  const profileChange = (val, type) => {
    if (type === "ai") {
      s_aiProfile(val);
    } else {
      s_viewProfile(val);
    }
  };

  const checkInCameraHandle = () => {
    if (checkInCamera) {
      s_isCheckInCamera(false);
    } else {
      s_isCheckInCamera({
        _id: camera._id,
        cameraId: camera._id,
        type: "CHECKIN",
      });
    }
  };

  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <ValidatorForm onSubmit={isConnected ? save : connect} onError={(errors) => console.log(errors)}>
        <DialogTitle id="alert-dialog-title">
          {newCamera ? <Tx>camera.add.title</Tx> : <Tx>camera.edit.title</Tx>}
        </DialogTitle>
        <DialogContent style={{ paddingTop: 5 }}>
          <FormControl fullWidth style={{ marginBottom: 10 }}>
            <InputLabel id="demo-simple-select-label">
              <Tx>camera.connectionType</Tx>
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={connectionType}
              label={<Tx>camera.connectionType</Tx>}
              onChange={(e) => {
                s_connectionType(e.target.value);
                s_connection_credentilas_changed(true);
                if (e.target.value === "ONVIF") {
                  s_open_discover_onvif_dialog(true);
                }
              }}
            >
              <MenuItem value={"ONVIF"}>
                <Tx>camera.onvif</Tx>
              </MenuItem>
              <MenuItem value={"MANUAL"}>
                <Tx>camera.manual</Tx>
              </MenuItem>
            </Select>
          </FormControl>

          <Divider style={{ marginBottom: 10 }} />

          <Text
            label="g.name"
            value={name}
            onChange={s_name}
            validators={["required"]}
            errorMessages={["this field is required"]}
          />

          <Divider style={{ marginBottom: 10 }} />

          {connectionType === "ONVIF" && (
            <>
              <Text
                label="camera.ip"
                value={ip}
                onChange={s_ip}
                disabled={true}
                onClick={() => {
                  s_open_discover_onvif_dialog(true);
                  s_connection_credentilas_changed(true);
                }}
                validators={["required"]}
                errorMessages={["this field is required"]}
              />

              <Text
                                label="serial number"
                                value={serial_number}
                                onChange={s_serial_number}
                                disabled={false}
                                validators={['required']}
                                errorMessages={['this field is required']} />

              <Divider style={{ marginBottom: 10 }} />

              <Text
                label="camera.username"
                value={username}
                onChange={(val) => {
                  s_username(val);
                  s_connection_credentilas_changed(true);
                }}
                validators={["required"]}
                errorMessages={["this field is required"]}
              />

              <Text
                label="camera.password"
                type="password"
                value={password}
                onChange={(val) => {
                  s_password(val);
                  s_connection_credentilas_changed(true);
                }}
                validators={["required"]}
                errorMessages={["this field is required"]}
              />

              <Divider style={{ marginBottom: 10 }} />
              <FormControl fullWidth style={{ marginBottom: 10 }}>
                <InputLabel id="ai-profile-select-label">AI Profile</InputLabel>
                <Select
                  labelId="ai-profile-select-label"
                  id="demo-simple-select"
                  value={aiProfile}
                  label="AI Profile"
                  onChange={(e) => {
                    profileChange(e.target.value, "ai");
                  }}
                >
                  {profile_list.map((pr, idx) => {
                    const encoding = pr?.video?.encoder?.encoding;
                    const frameRate = pr?.video?.encoder?.framerate;

                    const width = pr?.video?.encoder?.resolution?.width;
                    const height = pr?.video?.encoder?.resolution?.height;

                    return (
                      <MenuItem key={"oo" + idx + pr.name} value={pr.name}>
                        {pr.name} - width:{width}, height:{height}, framerate:
                        {frameRate}, encoding:{encoding}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel id="view-profile-select-label">
                  View Profile
                </InputLabel>
                <Select
                  labelId="view-profile-select-label"
                  id="demok-simple-select"
                  value={viewProfile}
                  label="View Profile"
                  onChange={(e) => {
                    profileChange(e.target.value, "view");
                  }}
                >
                  {profile_list.map((pr, idx) => {
                    const encoding = pr?.video?.encoder?.encoding;
                    const frameRate = pr?.video?.encoder?.framerate;

                    const width = pr?.video?.encoder?.resolution?.width;
                    const height = pr?.video?.encoder?.resolution?.height;

                    return (
                      <MenuItem key={"oo" + idx + pr.name} value={pr.name}>
                        {pr.name} - width:{width}, height:{height}, framerate:
                        {frameRate}, encoding:{encoding}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>

              <Divider style={{ marginBottom: 10 }} />

              <ActionsWrapperStyled>
                <FormControlLabel
                  control={
                    <Switch
                      onChange={(e) => {
                        s_cameraSiteType(e.target.checked ? "EXIT" : "");
                      }}
                      checked={cameraSiteType === "EXIT"}
                    />
                  }
                  label="Exit Camera"
                />
                <FormControlLabel
                  control={
                    <Switch
                      onChange={(e) => {
                        s_cameraSiteType(e.target.checked ? "CASH" : "");
                      }}
                      checked={cameraSiteType === "CASH"}
                    />
                  }
                  label="Cashier Camera"
                />

                <FormControlLabel
                  control={
                    <Switch
                      onChange={(e) => {
                        s_cameraSiteType(e.target.checked ? "CHECKIN" : "");
                      }}
                      checked={cameraSiteType === "CHECKIN"}
                    />
                  }
                  label="Check In Camera"
                />
              </ActionsWrapperStyled>
              <FormControl>
                <FormLabel id="camera-rotate">Rotate</FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="camera rorate"
                  defaultValue={rotate}
                  name="camera-rotate"
                  onChange={(e) => {
                    s_rotate(e.target.value);
                  }}
                >
                  <FormControlLabel value="0" control={<Radio />} label="0" />
                  <FormControlLabel value="90" control={<Radio />} label="90" />
                  <FormControlLabel
                    value="180"
                    control={<Radio />}
                    label="180"
                  />
                  <FormControlLabel
                    value="270"
                    control={<Radio />}
                    label="270"
                  />
                </RadioGroup>
              </FormControl>
            </>
          )}

          {connectionType === "MANUAL" && (
            <>
              <Text
                label="camera.rtspUrl"
                value={rtspUrl}
                onChange={s_rtspUrl}
                validators={["required"]}
                errorMessages={["this field is required"]}
              />
            </>
          )}

          {open_discover_onvif_dialog && (
            <DiscoverOnvifDialog
              edgeId={edgeId}
              onClose={(selectedOnvif) => {
                s_open_discover_onvif_dialog(false);
                if (selectedOnvif) {
                  s_ip(selectedOnvif.ip);
                  s_onvif_addr(selectedOnvif.onvif_addr);
                  s_serial_number(selectedOnvif.serial_number);
                  s_name(selectedOnvif.serial_number);
                } else {
                  onClose();
                }
              }}
            />
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>
            <Tx>g.cancel</Tx>
          </Button>
          <Button autoFocus type="submit" disabled={connecting}>
            {!isConnected ? <Tx>g.connect</Tx> : (connecting ? <Connecting /> : <Tx>g.save</Tx>)}
          </Button>
        </DialogActions>
      </ValidatorForm>
    </Dialog>
  );
}
